<template>
  <ProjectList />
</template>

<script>
import ProjectList from '../components/ProjectList'

export default {
  components: {
    ProjectList,
  },

  metaInfo: {
    title: 'Projects',
  },

  mounted() {
    if (!this.$store.state.loadingProjects) {
      this.$store.dispatch('loadProjects')
    }
  },
}
</script>
